import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import usePageTitle from '@hooks/usePageTitle';

import LayoutFooter from './LayoutFooter';
import LayoutHeader from './LayoutHeader';

/**
 * Layout component that wraps the application and renders the header and footer components.
 *
 * @returns
 */

interface LayoutProps {
  children?: ReactNode;
  title: string;
}

const Layout = ({ children, title }: LayoutProps) => {
  usePageTitle(title);

  return (
    <>
      <LayoutHeader />
      <main>
        <Outlet />
        {children}
      </main>
      <LayoutFooter />
    </>
  );
};

export default Layout;
